module.exports = __webpack_public_path__ + "static/media/Logo_Redondo_RD_Station.da702b3f.svg";